import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

const CARD_WIDTH = ['136px', '136px', '224px'];
const HORIZONTAL_CARD_HEIGHT = ['134px', '134px', '226px'];

themeStyles.addBaseStyles('MainContainer')(({ theme }) =>
  css({
    zIndex: '1',
    display: 'inline-flex',
    flexDirection: 'column',
    width: CARD_WIDTH,
    border: `1px solid ${theme.colors.grey[2]}`,
    borderRadius: '3px',
    position: 'relative',
    img: {
      width: '100%',
      height: ['100px', '100px', '164px'],
    },
    '&:hover': {
      border: `1px solid ${theme.colors.blue}`,
    },
    '&:focus-visible': {
      outline: `solid 4px ${theme.colors.aodaFocused}`,
      outlineOffset: '-4px',
    },
  }),
);

themeStyles.addBaseStyles('IconContainer')(
  css({
    backgroundColor: 'transparent',
    right: '16px',
    top: '16px',
    zIndex: 1,
    padding: 'zero',
    width: 'auto',
    height: 'auto',
  }),
);

themeStyles.addBaseStyles('TextContainer')(
  css({
    display: 'flex',
    flexDirection: 'column',
    px: 'm',
    pb: 'm',
    pt: ['s', 's', 'm'],
    rowGap: ['64px', '64px', '50px'],
  }),
);

themeStyles.addBaseStyles('PriceContainer')(
  css({
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    pt: 'm',
    alignItems: 'baseline',
    flexWrap: 'wrap',
    gap: 'xs',
  }),
);

themeStyles.addBaseStyles('PaymentFrequency')(() =>
  css({
    pb: 'zero',
  }),
);

themeStyles.addBaseStyles('ViewMoreContainer')(({ theme, isHorizontal }) =>
  css({
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'center',
    rowGap: '16px',
    width: isHorizontal ? '100%' : CARD_WIDTH,
    height: isHorizontal ? HORIZONTAL_CARD_HEIGHT : '100%',
    borderRadius: '3px',
    padding: 'm',
    backgroundColor: theme.colors.blue,
    color: theme.colors.white,
    '&:hover': {
      backgroundColor: theme.colors.darkBlue,
    },
    '&:focus-visible': {
      outline: `solid 4px ${theme.colors.red}`,
      outlineOffset: '-4px',
    },
  }),
);

themeStyles.addBaseStyles('ViewMoreHorizontalTitle')(() =>
  css({
    color: 'white',
    fontFamily: 'bold',
    fontSize: ['20px', '20px', '24px'],
    lineHeight: ['24px', '24px', '28px'],
  }),
);

themeStyles.addBaseStyles('LearnMoreCta')(() =>
  css({
    lineHeight: 'sm',
    textAlign: 'left',
    width: 'fit-content',
    maxWidth: ['102px', '102px', '190px'],
  }),
);

themeStyles.addBaseStyles('OpenMoreCta')(() =>
  css({
    textAlign: 'left',
    width: 'fit-content',
    lineHeight: '22px',
  }),
);

themeStyles.addBaseStyles('ConfigureBapWrapper')(({ isAutoHeight }) =>
  css({
    overflow: 'auto',
    overflowX: 'hidden',
    height: isAutoHeight ? ['100%', '100%', 'auto'] : 'auto',
    pl: ['20px', '20px', '24px'],
    pr: ['20px', '20px', '24px'],
    width: '100%',
    '@media screen and (min-width: 1280px)': {
      width: '516px',
    },
    '@media screen and (min-width: 1024px) and (max-width: 1279px)': {
      width: '390px',
    },
    '@media screen and (max-width: 1023px)': {
      width: '100%',
    },
  }),
);

themeStyles.addBaseStyles('AddToBuildIcon')(() =>
  css({
    width: ['34px', '34px', '45px'],
    height: ['34px', '34px', '45px'],
  }),
);

themeStyles.addBaseStyles('IncludedBadgeContainer')(() =>
  css({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'flex-end',
  }),
);

export default themeStyles;
